import { render } from "./createManual.vue?vue&type=template&id=262e7a7f"
import script from "./createManual.vue?vue&type=script&lang=js"
export * from "./createManual.vue?vue&type=script&lang=js"

import "./createManual.vue?vue&type=style&index=0&id=262e7a7f&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__